/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_Exp_BodyInputs */

const es_landing_mod_exp_body = /** @type {(inputs: Landing_Mod_Exp_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Súmate a una travesía con plazas libres o abre las tuyas. Más gente en el agua, gastos compartidos.`)
};

const gl_landing_mod_exp_body = /** @type {(inputs: Landing_Mod_Exp_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Súmate a unha travesía con prazas libres ou abre as túas. Máis xente na auga, gastos compartidos.`)
};

const en_landing_mod_exp_body = /** @type {(inputs: Landing_Mod_Exp_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join a trip with spare places or open yours. More people on the water, costs shared.`)
};

/**
* | output |
* | --- |
* | "Join a trip with spare places or open yours. More people on the water, costs shared." |
*
* @param {Landing_Mod_Exp_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_exp_body = /** @type {((inputs?: Landing_Mod_Exp_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_Exp_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_exp_body(inputs)
	if (locale === "en") return en_landing_mod_exp_body(inputs)
	return es_landing_mod_exp_body(inputs)
});